import Cookies from 'js-cookie'

const cookies = {}

// 存储 cookie 值
cookies.set = function(name = 'default', value = '', cookieSetting = {}) {
	const currentCookieSetting = { expires: 7 } // 默认为一天过期
	Object.assign(currentCookieSetting, cookieSetting)
	Cookies.set(`examination-${name}`, value, currentCookieSetting)
}

// 拿到 cookie 值
cookies.get = function(name = 'default') {
	return Cookies.get(`examination-${name}`)
}

// 拿到 cookie 全部的值
cookies.getAll = function() {
	return Cookies.get()
}

// 删除 cookie
cookies.remove = function(name = 'default') {
	return Cookies.remove(`examination-${name}`)
}

export default cookies
